import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { WebhookEvent, WebhookEventStatus } from 'dashboard/models/webhook-event';
import Sticker from 'design-system/components/Sticker';
import { assertNever } from 'lib/utils/types';

const StickerContainer = styled('div')`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;

  grid-column-gap: ${Spacing[2]};
  grid-row-gap: ${Spacing[2]};
`;

interface WebhookEventStatusStickerProps {
  webhookEvent: WebhookEvent;
}

const WebhookEventStatusSticker = ({ webhookEvent }: WebhookEventStatusStickerProps) => {
  const displayResultCode = webhookEvent.attributes['result-code'] || 'Timeout';

  switch (webhookEvent.attributes.status) {
    case WebhookEventStatus.Pending: {
      return (
        <StickerContainer>
          <Sticker variant='caution'>Pending ({displayResultCode})</Sticker>
        </StickerContainer>
      );
    }
    case WebhookEventStatus.Completed: {
      return (
        <StickerContainer>
          <Sticker variant='success'>Success ({displayResultCode})</Sticker>
        </StickerContainer>
      );
    }
    case WebhookEventStatus.Failed: {
      return (
        <StickerContainer>
          <Sticker variant='danger'>Failed ({displayResultCode})</Sticker>
        </StickerContainer>
      );
    }
    case WebhookEventStatus.Skipped: {
      return (
        <StickerContainer>
          <Sticker variant='teal'>Skipped</Sticker>
        </StickerContainer>
      );
    }
    default:
      return assertNever(webhookEvent.attributes.status);
  }
};

export default WebhookEventStatusSticker;
